import React, { useState } from 'react';
import Button from '../../components/UI/Button/Button';
import MyProfileInput from '../../components/MyProfile/MyProfileInput/MyProfileInput';
import Dropdown from 'react-dropdown';
import { countryList } from '../../components/CountryValues/CountryValues';
import { VALIDATOR_EMAIL, VALIDATOR_ENGLISH_CHARACTERS_NOT_REQUIRED, VALIDATOR_REQUIRE } from '../../utils/validators';
import { useForm } from '../../hooks/form-hook';
import Modal from 'react-modal';
import { AvatarPicker } from '../../components/AvatarPicker/AvatarPicker';
import { useHttpClient } from '../../hooks/http-hook';
import LoadingSpinner from '../../components/UI/LoadingSpinner/LoadingSpinner';
import DefaultAvatar from '../../assets/images/profile-avatars/avatar.svg?react';
import './RequiredMemberForm.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 540,
    height: 630,
    background: '#FFFFFF',
    border: '1px solid #FFFFFF',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1), 0px 0px 30px rgba(0, 0, 0, 0.15)',
    borderRadius: '7px',
    padding: 0
  }
};

Modal.setAppElement('body');
Modal.defaultStyles.overlay.backgroundColor = 'rgba(0, 0, 0, 0.32)';

const RequiredMemberForm = (props) => {
  const { setIsActive, email } = props;
  const { isLoading, sendRequest } = useHttpClient();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [country, setCountry] = useState('');
  const [userData, setUserData] = useState(null);
  const [avatarSrc, setAvatarSrc] = React.useState(DefaultAvatar);
  // 'https://picsum.photos/200/300?grayscale'

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const [formState, inputHandler] = useForm(
    {
      name: {
        value: '',
        isValid: false
      },
      nickname: {
        value: '',
        isValid: true
      },
      email: {
        value: props.email,
        isValid: true
      },
      company: {
        value: '',
        isValid: false
      },
      jobTitle: {
        value: '',
        isValid: false
      },
      department: {
        value: '',
        isValid: false
      }
    },
    false
  );

  const updateProfileInformation = async () => {
    let body = {
      company: formState.inputs.company.value,
      department: formState.inputs.department.value,
      email: formState.inputs.email.value,
      image: avatarSrc,
      jobTitle: formState.inputs.jobTitle.value,
      location: country.value,
      nameAndSurname: formState.inputs.name.value,
      nickName: formState.inputs.nickname.value
    };
    const responseData = await sendRequest(
      import.meta.env.VITE_BACKEND_URL + `/api/users/changeData`,
      'POST',
      JSON.stringify(body),
      {
        'Content-Type': 'application/json'
      }
    );
    setUserData(responseData);
    setIsActive(true);
  };

  return (
    <div className="profile-container">
      {isLoading && (
        <div className="center" style={{ width: '100%' }}>
          <LoadingSpinner />
        </div>
      )}
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Avatar Picker">
        <AvatarPicker onClose={closeModal} setAvatarSrc={setAvatarSrc} />
      </Modal>
      {!isLoading && (
        <div className="profile-container__avatar" onClick={openModal}>
          <div className="avatar-overlay">Edit</div>
          <img className="profile-container__avatar-image" src={avatarSrc} alt="" />
        </div>
      )}

      {!isLoading && (
        <form className="profile-container__inputs" onSubmit={updateProfileInformation}>
          <ul>
            <MyProfileInput
              id="name"
              element="input"
              type="text"
              label="name and surname"
              initialValue={''}
              errorText="Please provide your full name."
              onInput={inputHandler}
              validators={[VALIDATOR_REQUIRE()]}
            />
            <MyProfileInput
              id="nickname"
              type="text"
              element="input"
              label="nickname"
              errorText="Please use only english characters."
              onInput={inputHandler}
              initialValue={''}
              validators={[VALIDATOR_ENGLISH_CHARACTERS_NOT_REQUIRED()]}
              initialValid={true}
            />
            <MyProfileInput
              id="email"
              type="text"
              element="input"
              label="e-mail"
              initialValue={props.email}
              errorText="Please provide your work email."
              onInput={inputHandler}
              validators={[VALIDATOR_EMAIL()]}
              disabled
              initialValid={true}
            />
            <MyProfileInput
              id="company"
              type="text"
              element="input"
              label="company"
              initialValue={''}
              errorText="Please provide a company you are working at."
              onInput={inputHandler}
              validators={[VALIDATOR_REQUIRE()]}
            />
            <MyProfileInput
              id="jobTitle"
              type="text"
              element="input"
              label="job title"
              initialValue={''}
              errorText="Please provide your job title."
              onInput={inputHandler}
              validators={[VALIDATOR_REQUIRE()]}
            />
            <MyProfileInput
              id="department"
              type="text"
              element="input"
              label="department"
              initialValue={''}
              errorText="Please provide your department."
              onInput={inputHandler}
              validators={[VALIDATOR_REQUIRE()]}
            />
            <div className="country-dropdown">
              <label className="input-placeholder">location</label>
              <div className="country-line"></div>
              <Dropdown
                options={countryList}
                onChange={(val) => setCountry(val)}
                value={country.value}
                className="location-dropdown"
              />
            </div>
            <div className="buttons-container">
              <Button inverseBlack type="submit" disabled={!(formState.isValid && country.value)}>
                Save
              </Button>
              <Button blackText__border>Cancel</Button>
            </div>
          </ul>
        </form>
      )}
    </div>
  );
};

export default RequiredMemberForm;
